'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _proptypes = require('proptypes');

var _proptypes2 = _interopRequireDefault(_proptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wixBridgeActions = [{
    type: 'EDIT_MODE_CHANGE',
    propTypes: {
        editMode: _proptypes2.default.string
    }
}];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(wixBridgeActions, 'WIX_BRIDGE_');
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(wixBridgeActions, 'WIX_BRIDGE_');